import { render } from "./PersonalizationButton.vue?vue&type=template&id=0c0203a3"
import script from "./PersonalizationButton.vue?vue&type=script&lang=js"
export * from "./PersonalizationButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__